import { Translation } from 'primeng/api';

/**
 * Textos de PrimeNG en espanol.
 *
 * PrimeNG mantiene su propio diccionario y **no** lee `LOCALE_ID` de Angular:
 * sin esto el `p-datepicker` escribe "January" y "Mo Tu We" en un formulario que
 * por lo demas esta en espanol.
 *
 * Solo lo que el flujo usa. Ampliarlo a mano con las cuarenta claves que trae la
 * libreria seria escribir texto que ningun componente pide todavia.
 */
export const TRADUCCION_ES: Translation = {
  dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
  dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
  dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
  monthNames: [
    'enero',
    'febrero',
    'marzo',
    'abril',
    'mayo',
    'junio',
    'julio',
    'agosto',
    'septiembre',
    'octubre',
    'noviembre',
    'diciembre',
  ],
  monthNamesShort: [
    'ene',
    'feb',
    'mar',
    'abr',
    'may',
    'jun',
    'jul',
    'ago',
    'sep',
    'oct',
    'nov',
    'dic',
  ],
  today: 'Hoy',
  clear: 'Limpiar',
  // Lunes: es como empieza la semana en Colombia.
  firstDayOfWeek: 1,
  dateFormat: 'dd/mm/yy',
  emptyMessage: 'Sin resultados',
  emptySelectionMessage: 'Sin selección',
  emptyFilterMessage: 'Sin resultados',

  // Cadenas del calendario que **solo** oye quien usa lector de pantalla. Se
  // olvidan justamente porque no se ven: el boton que abre el calendario
  // anunciaba "Choose Date" en un formulario que por lo demas esta en espanol.
  chooseDate: 'Elegir fecha',
  chooseYear: 'Elegir año',
  chooseMonth: 'Elegir mes',
  prevYear: 'Año anterior',
  nextYear: 'Año siguiente',
  prevMonth: 'Mes anterior',
  nextMonth: 'Mes siguiente',
  prevDecade: 'Década anterior',
  nextDecade: 'Década siguiente',

  aria: {
    close: 'Cerrar',
    previous: 'Anterior',
    next: 'Siguiente',
    navigation: 'Navegación',
    selectAll: 'Seleccionar todo',
    unselectAll: 'Quitar toda la selección',
  },
};
